import { computed } from 'vue';

import { useDeviceLayout } from '@resn/gozer-vue';

export const useLayout = () => {
    const { layout } = useDeviceLayout();
    const isMobileLayout = computed(() => layout.value === 'mobile');
    const isDesktopLayout = computed(() => layout.value === 'desktop');

    return {
        layout,
        isMobileLayout,
        isDesktopLayout,
    };
};
